import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Flex, Box } from 'reflexbox'
import T from 'i18n-react'
import hideOnAnyRoles from 'containers/Role/Hide/AnyGlobalRoles'
import { GLOBAL_ROLES } from 'containers/Role/constants'
import { mapProps, compose } from 'recompose'

import Body from 'components/typography/body2/index'

import styles from './styles.scss'

const InternalText = compose(
  mapProps((props) => ({
    ...props,
    roles: [ GLOBAL_ROLES.CLIENT_ACCESS ]
  })),
  hideOnAnyRoles,
)(Body)

const Header = props => {
  return (
    <Flex styleName='header' auto>
      <Box styleName='nameHeader'>
        <Body>{T.translate('containers.project.fileSection.header.name')}</Body>
      </Box>
      <Box styleName='descriptionHeader'>
        <Body>{T.translate('containers.project.fileSection.header.description')}</Body>
      </Box>
      <Box styleName='internalHeader'>
        <InternalText>{T.translate('containers.project.fileSection.header.internal')}</InternalText>
      </Box>
      <Box styleName='fileType'>
        <Body>{T.translate('containers.project.fileSection.header.type')}</Body>
      </Box>
      <Box styleName='dateHeader'>
        <Body>{T.translate('containers.project.fileSection.header.uploadDate')}</Body>
      </Box>
      <Box styleName='sizeHeader'>
        <Body>{T.translate('containers.project.fileSection.header.size')}</Body>
      </Box>
    </Flex>
  )
}

const withStyle = CSSModules(styles)
export default withStyle(Header)
